import MatProperty from "@/components/Mat/MatProperty";
import { MatCard } from "@/components/Mat";

interface IProps {
  item: IMatIntegrationConfigurationItem;
  channel: IContactChannel | null;
}

const MatItem = ({ item, channel }: IProps) => {
  const { properties } = item;

  const renderNonVideos = () =>
    properties
      ?.filter(property => property.type !== "VIDEO")
      ?.map((property, index) => (
        <MatProperty key={index} property={property} />
      ));

  const renderVideos = () =>
    properties
      ?.filter(property => property.type === "VIDEO")
      ?.map((property, index) => (
        <MatProperty key={index} property={property} />
      ));

  return (
    <div className="mb-40">
      <MatCard
        renderNonVideos={renderNonVideos}
        renderVideos={renderVideos}
        channel={channel}
        {...item}
      />
    </div>
  );
};

export default MatItem;
